const INITIAL_STATE = 'INITIAL_STATE'
const CHANGE_REVIEWED_STATUS_FOR_FIRST_VISIT = 'CHANGE_REVIEWED_STATUS_FOR_FIRST_VISIT'
const CHECK_SURVEY_VARIANT = 'CHECK_SURVEY_VARIANT'
const SET_NUMBER_OF_ATTEMPTS_SURVEY_PLAN = 'SET_NUMBER_OF_ATTEMPTS_SURVEY_PLAN'
const SET_IS_FINAL_STATE_SURVEY_PLAN = 'SET_IS_FINAL_STATE_SURVEY_PLAN'
const CHANGE_REVIEWED_STATUS_FOR_SURVEY_RESULTS = 'CHANGE_REVIEWED_STATUS_FOR_SURVEY_RESULTS'
const CHANGE_REVIEWED_STATUS_FOR_TREATMENT_RESULTS = 'CHANGE_REVIEWED_STATUS_FOR_TREATMENT_RESULTS'
const CHECK_PRINCIPAL_DIAGNOSIS = 'CHECK_PRINCIPAL_DIAGNOSIS'
const SET_NUMBER_OF_ATTEMPTS_PRINCIPAL_DIAGNOSIS = 'SET_NUMBER_OF_ATTEMPTS_PRINCIPAL_DIAGNOSIS'
const SET_IS_FINAL_STATE_PRINCIPAL_DIAGNOSIS = 'SET_IS_FINAL_STATE_PRINCIPAL_DIAGNOSIS'
const CHECK_FACTORS = 'CHECK_FACTORS'
const SET_NUMBER_OF_ATTEMPTS_FACTORS = 'SET_NUMBER_OF_ATTEMPTS_FACTORS'
const SET_IS_FINAL_STATE_FACTORS = 'SET_IS_FINAL_STATE_FACTORS'
const CHECK_TREATMENT = 'CHECK_TREATMENT'
const SET_NUMBER_OF_ATTEMPTS_TREATMENT = 'SET_NUMBER_OF_ATTEMPTS_TREATMENT'
const SET_IS_FINAL_STATE_TREATMENT = 'SET_IS_FINAL_STATE_TREATMENT'
const CHECK_ALPHA_ADRENOBLOCKER = 'CHECK_ALPHA_ADRENOBLOCKER'
const SET_NUMBER_OF_ATTEMPTS_ALPHA_ADRENOBLOCKER = 'SET_NUMBER_OF_ATTEMPTS_ALPHA_ADRENOBLOCKER'
const SET_IS_FINAL_STATE_ALPHA_ADRENOBLOCKER = 'SET_IS_FINAL_STATE_ALPHA_ADRENOBLOCKER'
const CHECK_FUTURE_TREATMENT = 'CHECK_FUTURE_TREATMENT'
const SET_NUMBER_OF_ATTEMPTS_FUTURE_TREATMENT = 'SET_NUMBER_OF_ATTEMPTS_FUTURE_TREATMENT'
const SET_IS_FINAL_STATE_FUTURE_TREATMENT = 'SET_IS_FINAL_STATE_FUTURE_TREATMENT'
const SET_CURRENT_STAGE_SURVEY_PLAN = 'SET_CURRENT_STAGE_SURVEY_PLAN'
const SET_CURRENT_STAGE_SURVEY_RESULT = 'SET_CURRENT_STAGE_SURVEY_RESULT'
const SET_CURRENT_STAGE_PRINCIPAL_DIAGNOSIS = 'SET_CURRENT_STAGE_PRINCIPAL_DIAGNOSIS'
const SET_CURRENT_STAGE_FACTORS = 'SET_CURRENT_STAGE_FACTORS'
const SET_CURRENT_STAGE_TREATMENT = 'SET_CURRENT_STAGE_TREATMENT'
const SET_CURRENT_STAGE_ALPHA_ADRENOBLOCKER = 'SET_CURRENT_STAGE_ALPHA_ADRENOBLOCKER'
const SET_CURRENT_STAGE_FUTURE_TREATMENT = 'SET_CURRENT_STAGE_FUTURE_TREATMENT'
const SET_CURRENT_STAGE_RESULT_OF_TREATMENT = 'SET_CURRENT_STAGE_RESULT_OF_TREATMENT'
const SET_COMMENTARY = 'SET_COMMENTARY'

let initialStateCase = {
    cover: {
        image: '',
        description: ''
    },
    firstVisitToTheDoctor: [{
        defaultImage: '',
        cardName: '',
        cardDescription: '',
        typesDescription: [
            {
                type: '',
                description: ''
            }], // параметр ?
        isReviewed: false
    }],
    surveyPlan: {
        numberOfAttempts: 0,
        isFinalState: false,
        hint: {
            title: "",
            image: null,
            description: '',
            list: [],
            footer: ""
        },
        variants: [{
            variantName: '',
            isChecked: false,
            isCorrectVariant: false // правильный или не правильный это вариант
        }],
        isCurrentStage: false,
        commentary: ''
    },
    surveyResults: {
        isCurrentStage: false,
        results: [
            {
                defaultImage: "",
                cardName: "",
                cardDescription: {
                    head: '',
                    description: ''
                },
                descriptionImage: null,
                isReviewed: false
            }
        ]
    },
    principalDiagnosis: {
        headName: '',
        numberOfAttempts: 0,
        isFinalState: false, // финальное состояние когда уже ничего нельзя поменять в вариантах ответов
        hint: {
            title: "",
            image: null,
            description: '',
            list: [],
            footer: ""
        },
        variants: [{
            variantName: '',
            isChecked: false,
            isCorrectVariant: false // правильный или не правильный это вариант
        }],
        isCurrentStage: false,
        commentary: ''
    },
    progressionFactors: {
        headName: '',
        numberOfAttempts: 0,
        isFinalState: false, // финальное состояние когда уже ничего нельзя поменять в вариантах ответов
        hint: {
            title: "",
            image: null,
            description: '',
            list: [],
            footer: ""
        },
        variants: [{
            variantName: '',
            isChecked: false,
            isCorrectVariant: false // правильный или не правильный это вариант
        }],
        isCurrentStage: false,
        commentary: ''
    },
    treatment: {
        headName: '',
        numberOfAttempts: 0,
        isFinalState: false,
        hint: {
            title: "",
            image: null,
            description: '',
            list: [],
            footer: ""
        },
        variants: [{
            variantName: '',
            isChecked: false,
            isCorrectVariant: false // правильный или не правильный это вариант
        }],
        isCurrentStage: false,
        commentary: ''
    },
    alpha_adrenoblocker: {
        headName: "",
        numberOfAttempts: 0,
        isFinalState: false,
        hint: {
            title: "",
            image: null,
            description: "",
            list: [],
            footer: ""
        },
        variants: [
            {
                variantName: "",
                isChecked: false,
                isCorrectVariant: false
            }
        ],
        isCurrentStage: false,
        commentary: ""
    },
    resultsOfTreatment: {
        description: '',
        descriptionImage: '',
        isCurrentStage: false
    },
    futureTreatment: {
        headName: '',
        numberOfAttempts: 0,
        isFinalState: false,
        hint: {
            title: "",
            image: null,
            description: '',
            list: [],
            footer: ""
        },
        variants: [{
            variantName: '',
            isChecked: false,
            isCorrectVariant: false // правильный или не правильный это вариант
        }],
        isCurrentStage: false,
        commentary: ''
    }
};

const currentCaseState = (state = initialStateCase, action) => {
    switch (action.type) {
        case INITIAL_STATE:
            return {
                ...state,
                ...action.state
            }
        case CHANGE_REVIEWED_STATUS_FOR_FIRST_VISIT:
            return {
                ...state,
                firstVisitToTheDoctor: state.firstVisitToTheDoctor.filter((block, index) => {
                    if (index === action.index) block.isReviewed = true
                    return block
                })
            }
        case CHECK_SURVEY_VARIANT:
            return {
                ...state,
                surveyPlan: {
                    ...state.surveyPlan, variants: state.surveyPlan.variants.filter((variant, index) => {
                        if (index === action.index) variant.isChecked = !variant.isChecked
                        return variant
                    })
                }

            }
        case SET_NUMBER_OF_ATTEMPTS_SURVEY_PLAN:
            return {
                ...state,
                surveyPlan: { ...state.surveyPlan, numberOfAttempts: state.surveyPlan.numberOfAttempts += 1 }
            }
        case SET_IS_FINAL_STATE_SURVEY_PLAN:
            return {
                ...state,
                surveyPlan: { ...state.surveyPlan, isFinalState: true }
            }
        case CHANGE_REVIEWED_STATUS_FOR_SURVEY_RESULTS:
            return {
                ...state,
                surveyResults: {
                    ...state.surveyResults, results: state.surveyResults.results.filter((result, index) => {
                        if (index === action.index) result.isReviewed = true
                        return result
                    })
                }
            }
        case CHANGE_REVIEWED_STATUS_FOR_TREATMENT_RESULTS:
            return {
                ...state,
                resultsOfTreatment: {
                    ...state.resultsOfTreatment, results: state.resultsOfTreatment.results.filter((result, index) => {
                        if (index === action.index) result.isReviewed = true
                        return result
                    })
                }
            }
        case CHECK_PRINCIPAL_DIAGNOSIS:
            return {
                ...state,
                principalDiagnosis: {
                    ...state.principalDiagnosis, variants: state.principalDiagnosis.variants.filter((variant, index) => {
                        // if (index == action.index && variant.isChecked) {
                        //     variant.isChecked = true
                        // } else  {
                        //     variant.isChecked = false
                        // }
                        if (index == action.index) variant.isChecked = !variant.isChecked
                        return variant
                    })
                }
            }
        case SET_NUMBER_OF_ATTEMPTS_PRINCIPAL_DIAGNOSIS:
            return {
                ...state,
                principalDiagnosis: { ...state.principalDiagnosis, numberOfAttempts: state.principalDiagnosis.numberOfAttempts += 1 },
            }
        case SET_IS_FINAL_STATE_PRINCIPAL_DIAGNOSIS:
            return {
                ...state,
                principalDiagnosis: { ...state.principalDiagnosis, isFinalState: true }
            }
        case CHECK_FACTORS:
            return {
                ...state,
                progressionFactors: {
                    ...state.progressionFactors, variants: state.progressionFactors.variants.filter((variant, index) => {
                        if (index === action.index) variant.isChecked = !variant.isChecked
                        return variant
                    })
                }
            }
        case SET_NUMBER_OF_ATTEMPTS_FACTORS:
            return {
                ...state,
                progressionFactors: { ...state.progressionFactors, numberOfAttempts: state.progressionFactors.numberOfAttempts += 1 },
            }
        case SET_IS_FINAL_STATE_FACTORS:
            return {
                ...state,
                progressionFactors: { ...state.progressionFactors, isFinalState: true }
            }
        case CHECK_TREATMENT:
            return {
                ...state,
                treatment: {
                    ...state.treatment, variants: state.treatment.variants.filter((variant, index) => {
                        if (index === action.index) variant.isChecked = !variant.isChecked
                        return variant
                    })
                }
            }
        case SET_NUMBER_OF_ATTEMPTS_TREATMENT:
            return {
                ...state,
                treatment: { ...state.treatment, numberOfAttempts: state.treatment.numberOfAttempts += 1 }
            }
        case SET_IS_FINAL_STATE_TREATMENT:
            return {
                ...state,
                treatment: { ...state.treatment, isFinalState: true }
            }
        case CHECK_ALPHA_ADRENOBLOCKER:
            return {
                ...state,
                alpha_adrenoblocker: {
                    ...state.alpha_adrenoblocker, variants: state.alpha_adrenoblocker.variants.filter((variant, index) => {
                        if (index == action.index && variant.isChecked) {
                            variant.isChecked = true
                        } else {
                            variant.isChecked = false
                        }
                        if (index == action.index) variant.isChecked = !variant.isChecked
                        return variant
                    })
                }
            }
        case SET_NUMBER_OF_ATTEMPTS_ALPHA_ADRENOBLOCKER:
            return {
                ...state,
                alpha_adrenoblocker: { ...state.alpha_adrenoblocker, numberOfAttempts: state.alpha_adrenoblocker.numberOfAttempts += 1 }
            }
        case SET_IS_FINAL_STATE_ALPHA_ADRENOBLOCKER:
            return {
                ...state,
                alpha_adrenoblocker: { ...state.alpha_adrenoblocker, isFinalState: true }
            }
        case CHECK_FUTURE_TREATMENT:
            return {
                ...state,
                futureTreatment: {
                    ...state.futureTreatment, variants: state.futureTreatment.variants.filter((variant, index) => {
                        if (index == action.index && variant.isChecked) {
                            variant.isChecked = true
                        } else {
                            variant.isChecked = false
                        }
                        if (index == action.index) variant.isChecked = !variant.isChecked
                        return variant
                    })
                }
            }
        case SET_NUMBER_OF_ATTEMPTS_FUTURE_TREATMENT:
            return {
                ...state,
                futureTreatment: { ...state.futureTreatment, numberOfAttempts: state.futureTreatment.numberOfAttempts += 1 }
            }
        case SET_IS_FINAL_STATE_FUTURE_TREATMENT:
            return {
                ...state,
                futureTreatment: { ...state.futureTreatment, isFinalState: true }
            }
        case SET_CURRENT_STAGE_SURVEY_PLAN:
            return {
                ...state,
                surveyPlan: { ...state.surveyPlan, isCurrentStage: true }
            }
        case SET_CURRENT_STAGE_SURVEY_RESULT:
            return {
                ...state,
                surveyResults: { ...state.surveyResults, isCurrentStage: true }
            }
        case SET_CURRENT_STAGE_PRINCIPAL_DIAGNOSIS:
            return {
                ...state,
                principalDiagnosis: { ...state.principalDiagnosis, isCurrentStage: true }
            }
        case SET_CURRENT_STAGE_FACTORS:
            return {
                ...state,
                progressionFactors: { ...state.progressionFactors, isCurrentStage: true }
            }
        case SET_CURRENT_STAGE_TREATMENT:
            return {
                ...state,
                treatment: { ...state.treatment, isCurrentStage: true }
            }
        case SET_CURRENT_STAGE_ALPHA_ADRENOBLOCKER:
            return {
                ...state,
                alpha_adrenoblocker: { ...state.alpha_adrenoblocker, isCurrentStage: true }
            }
        case SET_CURRENT_STAGE_RESULT_OF_TREATMENT:
            return {
                ...state,
                resultsOfTreatment: { ...state.resultsOfTreatment, isCurrentStage: true }
            }
        case SET_CURRENT_STAGE_FUTURE_TREATMENT:
            return {
                ...state,
                futureTreatment: { ...state.futureTreatment, isCurrentStage: true }
            }
        case SET_COMMENTARY:
            if (action.component == 'survey-plan') {
                return {
                    ...state,
                    surveyPlan: { ...state.surveyPlan, commentary: action.commentary }
                }
            }
            if (action.component == 'diagnosis') {
                return {
                    ...state,
                    principalDiagnosis: { ...state.principalDiagnosis, commentary: action.commentary }
                }
            }
            if (action.component == 'factors') {
                return {
                    ...state,
                    progressionFactors: { ...state.progressionFactors, commentary: action.commentary }
                }
            }
            if (action.component == 'treatment') {
                return {
                    ...state,
                    treatment: { ...state.treatment, commentary: action.commentary }
                }
            }
            if (action.component == 'future-treatment') {
                return {
                    ...state,
                    futureTreatment: { ...state.futureTreatment, commentary: action.commentary }
                }
            }
            if (action.component == 'alpha-adrenoblocker') {
                return {
                    ...state,
                    alpha_adrenoblocker: { ...state.alpha_adrenoblocker, commentary: action.commentary }
                }
            }
        default:
            return state;
    }
};

export const initialStateAction = (state) => {
    return { type: INITIAL_STATE, state }
}
export const changeReviewedStatusForFirstVisitAction = (index) => {
    return { type: CHANGE_REVIEWED_STATUS_FOR_FIRST_VISIT, index }
}
export const checkSurveyVariantAction = (index) => {
    return { type: CHECK_SURVEY_VARIANT, index }
}
export const setNumberOfAttemptsSurveyPlanAction = () => {
    return { type: SET_NUMBER_OF_ATTEMPTS_SURVEY_PLAN }
}
export const setIsFinalStateSurveyPlanAction = () => {
    return { type: SET_IS_FINAL_STATE_SURVEY_PLAN }
}
export const changeReviewedStatusForSurveyResultsAction = (index) => {
    return { type: CHANGE_REVIEWED_STATUS_FOR_SURVEY_RESULTS, index }
}
export const changeReviewedStatusForTreatmentResultsAction = (index) => {
    return { type: CHANGE_REVIEWED_STATUS_FOR_TREATMENT_RESULTS, index }
}
export const checkPrincipalDiagnosisAction = (index) => {
    return { type: CHECK_PRINCIPAL_DIAGNOSIS, index }
}
export const setNumberOfAttemptsPrincipalDiagnosisAction = () => {
    return { type: SET_NUMBER_OF_ATTEMPTS_PRINCIPAL_DIAGNOSIS }
}
export const setIsFinalStatePrincipalDiagnosisAction = () => {
    return { type: SET_IS_FINAL_STATE_PRINCIPAL_DIAGNOSIS }
}
export const checkFactorsAction = (index) => {
    return { type: CHECK_FACTORS, index }
}
export const setNumberOfAttemptsFactorsAction = () => {
    return { type: SET_NUMBER_OF_ATTEMPTS_FACTORS }
}
export const setIsFinalStateFactorsAction = () => {
    return { type: SET_IS_FINAL_STATE_FACTORS }
}
export const checkTreatmentAction = (index) => {
    return { type: CHECK_TREATMENT, index }
}
export const setNumberOfAttemptsTreatmentAction = () => {
    return { type: SET_NUMBER_OF_ATTEMPTS_TREATMENT }
}
export const setIsFinalStateTreatmentAction = () => {
    return { type: SET_IS_FINAL_STATE_TREATMENT }
}
export const checkAlphaAdrenoblockerAction = (index) => {
    return { type: CHECK_ALPHA_ADRENOBLOCKER, index }
}
export const setNumberOfAttemptsAlphaAdrenoblockerAction = () => {
    return { type: SET_NUMBER_OF_ATTEMPTS_ALPHA_ADRENOBLOCKER }
}
export const setIsFinalStateAlphaAdrenoblockerAction = () => {
    return { type: SET_IS_FINAL_STATE_ALPHA_ADRENOBLOCKER }
}
export const checkFutureTreatmentAction = (index) => {
    return { type: CHECK_FUTURE_TREATMENT, index }
}
export const setNumberOfAttemptsFutureTreatmentAction = () => {
    return { type: SET_NUMBER_OF_ATTEMPTS_FUTURE_TREATMENT }
}
export const setIsFinalStateFutureTreatmentAction = () => {
    return { type: SET_IS_FINAL_STATE_FUTURE_TREATMENT }
}
export const setCurrentStageSurveyPlanAction = () => {
    return { type: SET_CURRENT_STAGE_SURVEY_PLAN }
}
export const setCurrentStageSurveyResultAction = () => {
    return { type: SET_CURRENT_STAGE_SURVEY_RESULT }
}
export const setCurrentStagePrincipalDiagnosisAction = () => {
    return { type: SET_CURRENT_STAGE_PRINCIPAL_DIAGNOSIS }
}
export const setCurrentStageFactorsAction = () => {
    return { type: SET_CURRENT_STAGE_FACTORS }
}
export const setCurrentStageTreatmentAction = () => {
    return { type: SET_CURRENT_STAGE_TREATMENT }
}
export const setCurrentStageAlphaAdrenoblockerAction = () => {
    return { type: SET_CURRENT_STAGE_ALPHA_ADRENOBLOCKER }
}
export const setCurrentStageFutureTreatmentAction = () => {
    return { type: SET_CURRENT_STAGE_FUTURE_TREATMENT }
}
export const setCurrentStageResultsOfTreatmentAction = () => {
    return { type: SET_CURRENT_STAGE_RESULT_OF_TREATMENT }
}
export const setCommentaryAction = (component, commentary) => {
    return { type: SET_COMMENTARY, component, commentary }
}


export default currentCaseState;
